import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import {
  getFavoriteContentWithHighestRank,
  hasEligibleFavoriteContent,
  ProductTypes,
  TvProduct,
} from '@dch/products-business-logic';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { getPiiServiceId } from 'src/app/shared/pii/pii.utils';
import { GetProductDetails } from 'src/app/store/actions/product-details.actions';
import {
  ApplicationState,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from 'src/app/store/reducers';

@Component({
  selector: 'mprd-tv-available-options-pxsplus',
  templateUrl: './tv-available-options-pxsplus.component.html',
})
export class TvAvailableOptionsPxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: TvProduct;
  tvBonusEligible: boolean;
  hasError: boolean;
  isPending: boolean;
  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.tvProductDetails) {
            this.selectedProduct = value.tvProductDetails;
            this.tvBonusEligible =
              this.selectedProduct &&
              (hasEligibleFavoriteContent(this.selectedProduct) ||
                !!getFavoriteContentWithHighestRank(this.selectedProduct));
          }
        }),
      );

      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: ProductTypes.TV.toString(),
              serviceId,
            }),
          );
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );

      this.addSubscription(
        this.store.select(getProductDetailsPending).subscribe((pending) => {
          this.isPending = pending;
        }),
      );

      this.scrollToTop();

      this.translationService.parse(this.elementRef.nativeElement);
    } else {
      this.router.navigate(['/overview']);
    }
  }
  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#tvLevelTwo');
    });
  }
}
